import { useQuery } from 'react-query';
import { getData } from '../models/tournaments/api';

export const useTournaments = () => {
  return useQuery(
    ['useTournaments'],
    async () => getData().then((result) => result.data),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
    }
  );
};
